import Vue from 'vue';

const getIcon = function(tipo) {
	switch (tipo) {
		case 'success':
			return 'checkmark box';
		case 'error':
			return 'times circle';
		case 'warning':
		case 'warn':
			return 'warning sign';
		case 'info':
			return 'circle info';
		default:
			return 'circle info';
	}
};

export default function Notification(tipo, title, msj) {
	const icon = getIcon(tipo);
	const message = msj ? `<p>${msj}</p>` : '';
	const content = `
		<div class="ui icon message" style="background: transparent!important; color: #ffffff; padding: 0;-webkit-box-shadow: none; box-shadow: none;">
			<i class="${icon} icon" style="width: none;"></i>
			<div class="content">
				<h3 class="header" style="color: #fff;line-height: 1.3em!important;">${title}</h3>
				${message}
			</div>
		</div>`;
	Vue.notify({
		//	title: content ,
		text: content,
		//		text: msj,
		type: tipo
	});
}
